import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import { newSearch } from '@/results/store/actions'

import { DEFAULT_SUGGESTION } from './defaultState'

const suggestion = handleActions({
  [newSearch.request]: () => null,
  [newSearch.success]: (_, { meta: { spellcheck = null } }) => spellcheck
}, DEFAULT_SUGGESTION)

export default combineReducers({
  suggestion
})
